import { z } from "zod";

export const baseAssistantFormSchema = z.object({
  userId: z.union([z.string(), z.number()]).optional(),
  firstName: z.string().trim().min(1, "First Name is required"),
  lastName: z.string().trim().min(1, "Last Name is required"),
  email: z.email("Email is invalid").min(1, "Email is required"),
  branches: z.array(z.union([z.string(), z.number()])).default([]),
  regions: z.array(z.union([z.string(), z.number()])).default([]),
  explicitPlayerIds: z.array(z.number()).default([]),
  isScoped: z.boolean().default(false),
  permissionsMap: z.record(z.string(), z.string()).default({}),
});

export const createAssistantSchema = baseAssistantFormSchema;

export const editAssistantSchema = baseAssistantFormSchema;

export type CreateAssistantFormValues = z.input<typeof createAssistantSchema>;
export type EditAssistantFormValues = z.input<typeof editAssistantSchema>;
export type CreateAssistantFormOutput = z.output<typeof createAssistantSchema>;
export type EditAssistantFormOutput = z.output<typeof editAssistantSchema>;
